import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { RestApi } from '../RestApi/restApi';

interface reportConfigurationInfo {
  message: any,
  error: boolean,
  data: any
}

@Injectable({
  providedIn: 'root'
})
export class ReportConfigurationService {

  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private Http: HttpClient, private rest: RestApi) { }

  retrieveObjects() {

    return this.Http.get<reportConfigurationInfo>(this.rest.RETRIEVE_OBJECTS_URL, { headers: this.headers })

  }
  // retrieveReportingSavedData(){
  //   return this.Http.get<reportConfigurationInfo>(this.rest.RETRIEVE_SAVEDDATA_URL, { headers: this.headers })
  // }

  // retrievesavedQueryforView(viewId){
  //   return this.Http.get<reportConfigurationInfo>(this.rest.RETRIEVE_VIEWQUERY_URL+"/"+viewId, { headers: this.headers })
  // }

  // editReportingData(updateId){
  //   return this.Http.get<reportConfigurationInfo>(this.rest.RETRIEVE_UPDATEQUERY_URL+"/"+updateId, { headers: this.headers })
  // }

  /*retrieveTables(object) {

    return this.Http.get<reportConfigurationInfo>(this.rest.RETRIEVE_TABLES_URL + "/" + object, { headers: this.headers })

  }*/

  retrieveTablesFields(object) {

    return this.Http.get<reportConfigurationInfo>(this.rest.RETRIEVE_TABLES_FIELDS_URL + "/" + object, { headers: this.headers })

  }
  // retrieverunquery(runquery) {
  //   return this.Http.post<reportConfigurationInfo>(this.rest.RETRIEVE_RUNQUERY_URL, JSON.stringify(runquery), { headers: this.headers })
  // }

  // updateReportData(updatequery){
  //   return this.Http.post<reportConfigurationInfo>(this.rest.RETRIEVE_RUNQUERY_URL, JSON.stringify(updatequery), { headers: this.headers })
  // }

  // saveReportingCopyData(copyquery){
  //   return this.Http.post<reportConfigurationInfo>(this.rest.RETRIEVE_COPYQUERY_URL, JSON.stringify(copyquery), { headers: this.headers })
  // }

  // deleteReportingData(deleteId){
  //   return this.Http.delete<reportConfigurationInfo>(this.rest.DELETE_REPORT_URL + "/" + deleteId, { headers: this.headers })
  // }

}
